/* eslint-disable sonarjs/no-duplicate-string */

import { GridColDef } from '@mui/x-data-grid';

export const columns: GridColDef[] = [];

export const rows = [];
